<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>신청서 종류</v-list-item-title>
          <v-list-item-subtitle> {{ applTitle }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청년도</v-list-item-title>
          <v-list-item-subtitle> {{ reqYy }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>용도</v-list-item-title>
          <v-list-item-subtitle> {{ purpose }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>제출처</v-list-item-title>
          <v-list-item-subtitle> {{ submitOffice }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item   v-show="emailAddrShow">
          <v-list-item-title>메일주소</v-list-item-title>
          <v-list-item-content> {{ emailAddr }} </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기타</v-list-item-title>
          <v-list-item-subtitle> {{ etc }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getReCertAppList, getReCertAppDetail } from '@/api/workStatus';
import { mapMutations } from 'vuex';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    applTitle: '',
    applCd: '',
    address: '',
    period: '',
    etc: '',
    purpose: '',
    purposeCd: '',
    submitOffice: '',
    reqYy: '',
    emailAddr: '',
    emailAddrShow: false,
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    call(sdate, edate) {
      var sdd = sdate;
      var edd = edate;

      var ar1 = sdd.split('-');
      var ar2 = edd.split('-');
      var da1 = new Date(ar1[0], ar1[1], ar1[2]);
      var da2 = new Date(ar2[0], ar2[1], ar2[2]);
      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30; // 월 만듬
      var cYear = cMonth * 12; // 년 만듬
      var mYear = parseInt(dif / cYear) * 12;

      if (sdd && edd) {
        this.period =
          sdate +
          ' ~ ' +
          edate +
          ' (' +
          parseInt(dif / cYear) +
          '년' +
          parseInt(dif / cMonth - mYear) +
          '개월)';
      }
    },
  },

  async created() {
    let response = await getReCertAppList(this.appInfoParam);
    if (response.data.data[0] !== undefined) {
      this.applTitle = response.data.data[0].applTitle;
      //this.address = response.data.data[0].address;
      //this.call(response.data.data[0].empYmd, response.data.data[0].currYmd);
    }

    response = await getReCertAppDetail(this.appInfoParam);
    this.purpose = response.data.data.purpose;
    this.submitOffice = response.data.data.submitOffice;
    this.etc = response.data.data.etc;
    this.reqYy = response.data.data.reqYy;

    this.emailAddr = response.data.data.emailAddr;

    if(this.emailAddr !== null)
    {
      this.emailAddrShow = true;
    }

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
